export default "__VITE_ASSET__CcqyUiSv__"